/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-new */
/* eslint-disable new-cap */
/* eslint-disable no-undef */
import { fabric } from 'fabric';
import { DocumentHighlightRectDto } from '@api/Api';

export type HighlightCreatorViewerActions = {
  selectComment: (id: string | null) => void;
  setCanvasMode: (mode: 'view' | 'edit') => void;
  setDocumentHighlight: (v: { text: string; rects: any[] } | null) => void;
};

// When a comment's pin or highlight was last clicked: that click selects the
// comment, it is not a click outside the selected one, which closes it
let lastCommentTargetClickAt = 0;

export function markCommentTargetClick() {
  lastCommentTargetClickAt = Date.now();
}

export function isCommentTargetClick() {
  return Date.now() - lastCommentTargetClickAt < 500;
}

export function bindOverObjectRef(
  group: fabric.Object,
  overObject?: { current: boolean }
) {
  if (!overObject) return;
  group.on('mouseover', () => {
    overObject.current = true;
  });
  group.on('mousedown:before', () => {
    overObject.current = true;
  });
  group.on('mouseout', () => {
    overObject.current = false;
  });
}

type HighlightCreatorProps = {
  canvas: fabric.Canvas;
  viewerActions?: HighlightCreatorViewerActions;
  commentId?: string;
  documentHighlight?: string | null;
  documentHighlightRects: DocumentHighlightRectDto[];
  overObject?: { current: boolean };
};

export const highlightCreator = ({
  canvas,
  viewerActions,
  commentId,
  documentHighlight,
  documentHighlightRects,
  overObject
}: HighlightCreatorProps) => {
  if (!documentHighlightRects?.length) return;
  const canvasZoom = canvas.getZoom();
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  const reacts = documentHighlightRects.map((item) => {
    const left = Math.floor((item.left / 100) * (canvasWidth / canvasZoom));
    const top = Math.floor((item.top / 100) * (canvasHeight / canvasZoom));
    const width = Math.ceil((item.width / 100) * (canvasWidth / canvasZoom));
    const height = (item.height / 100) * (canvasHeight / canvasZoom);
    return new fabric.Rect({
      left,
      top,
      width,
      height,
      fill: '#496afc',
      selectable: false
    });
  });
  const group = new fabric.Group(reacts);
  group.set({
    opacity: 0.2,
    selectable: false,
    hoverCursor: 'pointer',
    type: 'highlight'
  });
  group.setControlsVisibility({
    bl: false,
    br: false,
    mb: false,
    ml: false,
    mr: false,
    mt: false,
    tl: false,
    tr: false,
    mtr: false
  });
  bindOverObjectRef(group, overObject);

  group.on('mouseup', () => {
    if (overObject) overObject.current = false;
    if (!commentId || !viewerActions) return;
    markCommentTargetClick();
    viewerActions.selectComment(commentId);
    viewerActions.setCanvasMode('view');
    viewerActions.setDocumentHighlight(
      documentHighlight && documentHighlightRects?.length
        ? {
            text: documentHighlight,
            rects: documentHighlightRects
          }
        : null
    );
  });
  canvas.add(group);
};
